import { CARDS } from '../enums/cardTypes';

export const toPoint = (card, cardSum = 0) => {
  switch (card) {
    case CARDS.CLUBS_ACE:
    case CARDS.DIAMONDS_ACE:
    case CARDS.HEARTS_ACE:
    case CARDS.SPADES_ACE:
      if (cardSum + 11 > 21) return 1;
      return 11;
    case CARDS.CLUBS_2:
    case CARDS.DIAMONDS_2:
    case CARDS.HEARTS_2:
    case CARDS.SPADES_2:
      return 2;
    case CARDS.CLUBS_3:
    case CARDS.DIAMONDS_3:
    case CARDS.HEARTS_3:
    case CARDS.SPADES_3:
      return 3;
    case CARDS.CLUBS_4:
    case CARDS.DIAMONDS_4:
    case CARDS.HEARTS_4:
    case CARDS.SPADES_4:
      return 4;
    case CARDS.CLUBS_5:
    case CARDS.DIAMONDS_5:
    case CARDS.HEARTS_5:
    case CARDS.SPADES_5:
      return 5;
    case CARDS.CLUBS_6:
    case CARDS.DIAMONDS_6:
    case CARDS.HEARTS_6:
    case CARDS.SPADES_6:
      return 6;
    case CARDS.CLUBS_7:
    case CARDS.DIAMONDS_7:
    case CARDS.HEARTS_7:
    case CARDS.SPADES_7:
      return 7;
    case CARDS.CLUBS_8:
    case CARDS.DIAMONDS_8:
    case CARDS.HEARTS_8:
    case CARDS.SPADES_8:
      return 8;
    case CARDS.CLUBS_9:
    case CARDS.DIAMONDS_9:
    case CARDS.HEARTS_9:
    case CARDS.SPADES_9:
      return 9;
    case CARDS.CLUBS_10:
    case CARDS.DIAMONDS_10:
    case CARDS.HEARTS_10:
    case CARDS.SPADES_10:
    case CARDS.CLUBS_JACK:
    case CARDS.DIAMONDS_JACK:
    case CARDS.HEARTS_JACK:
    case CARDS.SPADES_JACK:
    case CARDS.CLUBS_QUEEN:
    case CARDS.DIAMONDS_QUEEN:
    case CARDS.HEARTS_QUEEN:
    case CARDS.SPADES_QUEEN:
    case CARDS.CLUBS_KING:
    case CARDS.DIAMONDS_KING:
    case CARDS.HEARTS_KING:
    case CARDS.SPADES_KING:
      return 10;
    default:
      return 0;
  }
};
